import React from 'react';
import classnames from 'classnames';
import { node, string, func } from 'prop-types';

class Grid extends React.Component {
  render() {
    const { children, className, forwardedRef, ...props } = this.props;

    return (
      <div
        {...props}
        ref={forwardedRef}
        className={classnames([
          'mdc-layout-grid',
          className,
        ])}
      >{children}</div>
    );
  }
}

Grid.propTypes = {
  children: node.isRequired,
  className: string,
  forwardedRef: func,
};

Grid.defaultProps = {
  className: undefined,
  forwardedRef: () => {},
};

export default Grid;
